import { html, LitElement } from 'lit-element';
import { latexToHTML } from '../headerBlocks/utils.js';
import { processEscapedMarkup } from '../../utils.js';

const getAnswer = model => {
  const { markup, choices, keyMode, expression, responses } = model || {};
  let a = 0;
  const charCode = keyMode === 'numbers' ? 49 : 65;

  switch (model.element) {
    case 'multiple-choice':
      return latexToHTML(
        (choices || [])
          .reduce((acc, choice, index) => {
            if (choice.correct) {
              acc.push(
                `${String.fromCharCode(index + charCode)}: ${choice.label}`
              );
            }

            return acc;
          }, [])
          .join(', ')
      );

    case 'math-inline':
      if (expression) {
        let occurrences = 0;

        const completeAnswer = expression.replace(/\{\{[^}]*\}\}/g, () => {
          if (responses[occurrences]) {
            occurrences += 1;
            // eslint-disable-next-line no-plusplus
            return responses[occurrences - 1].answer;
          }

          return '';
        });

        return latexToHTML(completeAnswer);
      }
      break;

    case 'explicit-constructed-response':
      return processEscapedMarkup(markup).replace(/\{\{[^}]*\}\}/g, () => {
        if (choices[a] && choices[a][0]) {
          a += 1;
          // eslint-disable-next-line no-plusplus
          return `<span class='answer underlined'>${
            choices[a - 1][0].label
          }</span>`;
        }

        return '';
      });
    default:
      return 'No answer defined';
  }

  return '';
};

/**
 * @element view-details-modal-multi-item
 * @prop {Object} response - Response
 * IMPORTANT: ONLY DISPLAYED FOR CORRECT RESPONSE
 */
export class ViewDetailsModalMultiItem extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { item } = this.response || {};
    const { markup, models } = item || {};

    if (!markup) return '';

    const markupSlots = models.map(model => {
      const answer = getAnswer(model);
      const { element, id } = model;

      return html`
        <span
          class="markup-response-value correct"
          slot="${element.toLowerCase()}-${id}"
        >
          <math-rendering-element .label="${answer}"></math-rendering-element>
        </span>
      `;
    });

    return html` <div class="modal-response-content">
      <markup-wrapper .markup="${markup}" .markupSlots="${markupSlots}">
      </markup-wrapper>
    </div>`;
  }
}

export default ViewDetailsModalMultiItem;
